// extracted by mini-css-extract-plugin
module.exports = {"container":"LostCardModal_container__uFPrZ","header":"LostCardModal_header__Uw9_l","title":"LostCardModal_title__1nlzh","subtitle":"LostCardModal_subtitle__1B7hY"};